<div
  class="io-workflows-root"
  [class.is-loading]="isLoading"
  [class.is-tablet]="screenMode === 'tablet'"
  [class.is-mobile]="screenMode === 'mobile'"
  [ngStyle]="rootStyles"
>
  <div class="topbar">
    <div class="topbar-left">
      <button class="btn-back" (click)="goBack()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <span class="breadcrumb-sep">{{ screenTitle }} /</span>
      <span class="pipeline-name">{{ pipelineLabel }}</span>
      <span class="version-badge">{{ workflows.length }} workflows</span>
    </div>
    <div class="topbar-right">
      <button class="btn-validate" (click)="validate()">Validate</button>
      <button class="btn-publish" [class.saving]="saveStatus === 'saving'" (click)="save()">
        <span *ngIf="saveStatus !== 'saving'">Save</span>
        <span *ngIf="saveStatus === 'saving'">Saving...</span>
      </button>
    </div>
  </div>

  <div class="nodes-header">
    <div class="nodes-title-group">
      <h2 class="nodes-title">{{ chainTitle }}</h2>
      <div class="nodes-meta">
        {{ workflows.length }} workflow{{ workflows.length !== 1 ? 's' : '' }} &middot; drag to reorder &middot; hover to configure
      </div>
    </div>
    <div class="nodes-controls">
      <div class="wf-search-wrap">
        <div class="wf-search-box" (click)="showSearchDropdown = !showSearchDropdown">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <circle cx="5.5" cy="5.5" r="4" stroke="currentColor" stroke-width="1.5" />
            <path d="M8.5 8.5L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <input
            class="wf-search-input"
            type="text"
            placeholder="Search registry..."
            [(ngModel)]="searchQuery"
            (click)="$event.stopPropagation(); showSearchDropdown = true"
            (input)="showSearchDropdown = true"
          />
          <svg class="chevron" [class.open]="showSearchDropdown" width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M2 4l3.5 3.5L9 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="wf-search-dropdown" *ngIf="showSearchDropdown">
          <div class="wf-dropdown-item" *ngFor="let name of filteredRegistry" (click)="loadFromRegistry(name)">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <rect x="1" y="1" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1" />
              <path d="M3 5h4M5 3v4" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
            </svg>
            {{ name }}
          </div>
          <div class="wf-dropdown-empty" *ngIf="!filteredRegistry.length">No results found</div>
        </div>
      </div>
      <button class="btn-add-node" (click)="openAddModal()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        Add
      </button>
    </div>
  </div>

  <div class="master-detail-layout" [class.dock-right]="dockSide === 'right'">
    <div class="flow-sidebar">
      <div class="chain-pill chain-prev" *ngIf="chainPrevId">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M3 7V3a2 2 0 0 1 4 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
          <path d="M3 7a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.2" />
        </svg>
        <span>&larr; {{ chainPrevId }}</span>
      </div>

      <div class="flow-terminal flow-start">
        <div class="ft-dot"></div>
        <div class="ft-text">
          <span class="ft-label">Pipeline start</span>
          <span class="ft-entity">Inbound / Outbound</span>
        </div>
      </div>

      <div class="flow-empty-connector" *ngIf="!workflows.length">
        <div class="fic-line long"></div>
        <div class="flow-add-first" (click)="openAddModal()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          Add your first workflow
        </div>
        <div class="fic-line long"></div>
      </div>

      <div class="flow-drop-zone" cdkDropList (cdkDropListDropped)="dropWorkflow($event)">
        <div
          class="flow-node-item"
          *ngFor="let workflow of workflows; let index = index; trackBy: trackById"
          cdkDrag
          (mouseenter)="selectWorkflow(workflow.id)"
        >
          <div *cdkDragPlaceholder class="flow-placeholder"></div>
          <div *cdkDragPreview class="flow-preview">{{ workflow.workflowName }}</div>

          <app-pipeline-flow-node
            *ngIf="useSharedFlowNode"
            [data]="buildFlowNodeData(workflow, index)"
          ></app-pipeline-flow-node>
        </div>
      </div>

      <div class="flow-terminal flow-end">
        <div class="ft-dot ft-dot-end"></div>
        <div class="ft-text">
          <span class="ft-label">Pipeline end</span>
          <span class="ft-approved">Executed</span>
        </div>
      </div>

      <div class="chain-pill chain-next" *ngIf="chainNextId">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M3 7V3a2 2 0 0 1 4 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
          <path d="M3 7a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.2" />
        </svg>
        <span>{{ chainNextId }} &rarr;</span>
      </div>
    </div>

    <ng-container *ngIf="selectedWorkflowDetailData as detailData; else emptyState">
      <app-io-workflow-detail [data]="detailData"></app-io-workflow-detail>
    </ng-container>

    <ng-template #emptyState>
      <div class="main-area">
        <div class="loading-shell" *ngIf="isLoading; else readyEmptyState">
          <div class="loading-shell-bar loading-shell-bar-lg"></div>
          <div class="loading-shell-grid">
            <div class="loading-shell-card" *ngFor="let card of [1, 2, 3]">
              <div class="loading-shell-bar loading-shell-bar-md"></div>
              <div class="loading-shell-bar"></div>
              <div class="loading-shell-bar loading-shell-bar-sm"></div>
            </div>
          </div>
        </div>

        <ng-template #readyEmptyState>
          <div class="empty-state">
          <div class="empty-state-icon">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="7" width="22" height="14" rx="3" />
              <path d="M9 14h10M14 10v8" stroke-linecap="round" />
            </svg>
          </div>
          <p>Select a workflow from the left<br />to configure its settings.</p>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>

  <div class="modal-overlay" *ngIf="showAddModal" (click)="closeAddModal($event)">
    <div class="modal-box">
      <div class="modal-header">
        <h3>Add Workflow</h3>
        <button class="modal-close" (click)="showAddModal = false">x</button>
      </div>
      <div class="modal-body">
        <div class="form-field">
          <label>Workflow Name *</label>
          <input type="text" [(ngModel)]="newWF.workflowName" placeholder="e.g. KBF_Scores_Inbound" />
        </div>
        <div class="form-field">
          <label>Entity Name</label>
          <input type="text" [(ngModel)]="newWF.entityName" placeholder="e.g. KBF" />
        </div>
        <div class="form-grid">
          <div class="form-field">
            <label>Type</label>
            <select [(ngModel)]="newWF.type">
              <option value="INBOUND">INBOUND</option>
              <option value="OUTBOUND">OUTBOUND</option>
            </select>
          </div>
          <div class="form-field">
            <label>Source Type</label>
            <select [(ngModel)]="newWF.sourceType">
              <option *ngFor="let sourceType of SOURCE_TYPES" [value]="sourceType">{{ sourceType }}</option>
            </select>
          </div>
          <div class="form-field">
            <label>Sink Type</label>
            <select [(ngModel)]="newWF.sinkType">
              <option *ngFor="let sinkType of SINK_TYPES" [value]="sinkType">{{ sinkType }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="showAddModal = false">Cancel</button>
        <button class="btn-confirm" (click)="confirmAddWorkflow()" [disabled]="!newWF.workflowName.trim()">Add Workflow</button>
      </div>
    </div>
  </div>

  <div class="toast" [class.visible]="toastVisible">{{ toastMessage }}</div>
</div>
